import { Component, OnInit } from '@angular/core';
import { FaqService } from '../faq.service';
import { Store } from '../../store';
import { debounce } from 'lodash';
import { OverlayService } from '../../services/overlay.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-faq-topics',
    templateUrl: './faq-topics.component.html',
    styleUrls: ['./faq-topics.component.scss']
})
export class FaqTopicsComponent implements OnInit {

    faq$ = this.store.select<any>('faq');
    overlays$ = this.store.select<any>('overlays');

    topic;
    params;
    toSave = [];
    faqs = [];

    confirmationData = {
        open: false,
        buttonText: 'Confirm',
        title: '',
        detail: '',
        data: undefined,
    };

    constructor(
        private faqService: FaqService,
        private store: Store,
        private overlayService: OverlayService,
        private router: Router,
        private toastrService: ToastrService,
    ) {
        this.filterSearch = debounce(this.filterSearch, 350);
    }

    ngOnInit(): void {
        this.loadFromStore();
        this.filterSearch();
    }

    loadFromStore() {
        const faq = this.store.selectForLocal('faq');
        this.params = faq.params;
        this.faqs = faq.data;
    }

    filterSearch() {
        this.params.page = 0;
        const faq = this.store.selectForLocal('faq');
        faq.params = this.params;
        this.store.set('faq', faq);
        this.search();
    }

    search() {
        this.faqService.findAllTopics().subscribe((data) => {
            this.faqs = data.data.data;
        });
    }

    addTopic() {
        this.topic = undefined;
        this.overlayService.toggle('faqTopic');
    }

    editTopic(topic) {
        this.topic = topic;
        this.overlayService.toggle('faqTopic');
    }

    toggleStatus(topic) {
        if (!topic.status) {
            topic.status = true;
        } else {
            topic.status = false;
        }
        this.faqService.update(topic).subscribe();
    }

    viewTopicQuestions(topic) {
        this.router.navigate(['cms', 'faq', topic.id]);
    }

    closeAction(e) {
        if (e.reload) {
            this.search();
        }
    }

    drop(e) {
        this.toSave = e;
        this.faqService.sortTopics(this.toSave).subscribe(data => {
        });
    }

    deleteConfirm(topic) {
        this.confirmationData.title = 'Please confirm you would like to delete this topic';
        this.confirmationData.data = {};
        this.confirmationData.detail = '';
        this.confirmationData.open = true;
        this.topic = topic;
    }

    confirmAction(e) {
        if (e.action) {
            this.topic.deleted = 1;
            this.faqService.update(this.topic).subscribe(data => {
                this.toastrService.success('Topic deleted');
                this.search();
            });
        }
        this.confirmationData.open = false;
    }
}
